module.exports = __webpack_public_path__ + "img/pizzeriano3-salat.7c495689.jpg";